import React from 'react'
import './ImageStyleSheet.css';

function EduThree() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/thsimg3.jpeg" className='img-view'/>
        </div>
    )
}

export default EduThree
